const strongRtl = /^[\u0591-\u07FF\uFB1D-\uFDFF\uFE70-\uFEFC]/;
export const hasStrongRtl = text => strongRtl.test(text);